<script setup lang="ts">
import { computed } from 'vue';
import {
    type Name,
    type NamedNode,
    type NameInput,
    getFullName,
    getShortName,
} from '../helpers/entity-name-inputs';

export type EntityNameSpanProps = {
    node?: Partial<NamedNode> | null | undefined;
    name?: Partial<Name> | null | undefined;
    full?: string | null | undefined;
    short?: string | null | undefined;
    value?: NameInput;
    loading?: boolean;
    size?: 'auto' | 'full' | 'short';
    container?: HTMLElement | null;
    placeholder?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    placeholderClass?: any;
};

const props = withDefaults(defineProps<EntityNameSpanProps>(), {
    node: undefined,
    name: undefined,
    full: null,
    short: null,
    value: null,
    loading: false,
    size: 'auto',
    container: null,
    placeholder: '-- geen naam --',
    placeholderClass: () => 'text-gray-200 text-sm font-italic',
});

const full = computed<string | null>(() =>
    getFullName(props.full ?? props.value ?? props.name ?? props.node)
);
const short = computed<string | null>(() =>
    getShortName(props.short ?? props.value ?? props.name ?? props.node)
);

const label = computed<string | null>(() => {
    switch (props.size) {
        case 'full':
            return full.value ?? short.value;
        case 'short':
            return short.value ?? full.value;
        default:
            return full.value ?? short.value;
    }
});
</script>

<template>
    <span class="entity-name">
        <template v-if="loading">
            <Skeleton />
        </template>
        <template v-else-if="label">
            {{ label }}
        </template>
        <template v-else>
            <span :class="placeholderClass">{{ props.placeholder }}</span>
        </template>
    </span>
</template>
